import { lazy, Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import CookieConsent from './components/CookieConsent';
import Home from './pages/Home';
import { motion, AnimatePresence } from 'motion/react';

const About = lazy(() => import('./pages/About'));
const BusinessProfile = lazy(() => import('./pages/BusinessProfile'));
const LatinDanceAcademy = lazy(() => import('./pages/LatinDanceAcademy'));
const Partners = lazy(() => import('./pages/Partners'));
const Join = lazy(() => import('./pages/Join'));
const Admin = lazy(() => import('./pages/Admin'));
const Events = lazy(() => import('./pages/Events'));
const PrivacyPolicy = lazy(() => import('./pages/PrivacyPolicy'));
const TermsOfUse = lazy(() => import('./pages/TermsOfUse'));
const RGConnections = lazy(() => import('./pages/RGConnections'));
const RGSpeedFriending = lazy(() => import('./pages/RGConnections/SpeedFriending'));
const RGSpeedDating = lazy(() => import('./pages/RGConnections/SpeedDating'));

const PageLoader = () => (
  <div className="flex items-center justify-center min-h-[60vh] font-sans">
    <div className="flex flex-col items-center gap-4">
      <div className="w-10 h-10 border-2 border-agora-rust border-t-transparent rounded-full animate-spin" />
      <span className="text-xs uppercase font-semibold tracking-widest text-agora-ink/40 font-mono">Loading...</span>
    </div>
  </div>
);

function AppContent() {
  const normalizedPath = window.location.pathname.replace(/\/$/, "");
  const isDanceAcademy = normalizedPath === '/latin-core-windsor' || normalizedPath === '/latin-dance-windsor' || normalizedPath === '/latincoredance' || normalizedPath === '/latin-core-dance' || normalizedPath === '/dance-academy';

  return (
    <div className={isDanceAcademy ? "min-h-screen" : "min-h-screen bg-[#FDFCFB] text-[#1A1A1A] font-sans selection:bg-[#E6D5B8] selection:text-[#1A1A1A]"}>
      {!isDanceAcademy && <Navbar />}
      <main className={isDanceAcademy ? "" : "pt-20"}>
        <AnimatePresence mode="wait">
          <Suspense fallback={<PageLoader />}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/join" element={<Join />} />
              <Route path="/events" element={<Events />} />
              <Route path="/partners" element={<Partners />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/latin-core-windsor" element={<Navigate to="/dance-academy" replace />} />
              <Route path="/latin-dance-windsor" element={<Navigate to="/dance-academy" replace />} />
              <Route path="/latincoredance" element={<Navigate to="/dance-academy" replace />} />
              <Route path="/latin-core-dance" element={<Navigate to="/dance-academy" replace />} />
              <Route path="/dance-academy" element={<LatinDanceAcademy />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/terms-of-use" element={<TermsOfUse />} />
              <Route path="/rg-connections" element={<RGConnections />} />
              <Route path="/rg-connections/rg-speed-friending" element={<RGSpeedFriending />} />
              <Route path="/rg-connections/rg-speed-dating" element={<RGSpeedDating />} />
              <Route path="/:slug" element={<BusinessProfile />} />
            </Routes>
          </Suspense>
        </AnimatePresence>
      </main>
      {!isDanceAcademy && <Footer />}
    </div>
  );
}

export default function App() {
  return (
    <Router>
      <ScrollToTop />
      <CookieConsent />
      <AppContent />
    </Router>
  );
}
